/* eslint-disable react/no-danger */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { captureException } from '@playbookux/playbook-web-core';
import withLayout from '../../../core/components/with-layout';
import { countryOptions } from '../sign-up-survey/options';

import Tabs from '../../constants/tabs';
import { patchProfile, getCurrentProfile } from '../../../core/actions';

import {
  FIND_SOCIAL_PROFILE_INFORMATION,
} from './graphql';

import {
  Bold,
  FirstNameBold,
  Country,
  LastNameBold,
  EmailBold,
  Button,
  Container,
  Email,
  ErrorMessage,
  Header,
  Link,
  Section,
  Segment,
  Text,
  Row,
  Checkbox,
  NameInput,
} from './styles';
import { validateForm } from './schema';

const acceptTermsText = `
  By clicking submit, you agree to the <a href="https://www.playbookux.com/terms-conditions/"
  target="_blank" rel="noopener noreferrer">terms & conditions</a>, <a href="https://www.playbookux.com/privacy-policy/"
  target="_blank" rel="noopener noreferrer">policy privacy</a> and <a href="https://www.playbookux.com/nda/"
  target="_blank" rel="noopener noreferrer">non-disclosure agreement</a>.
`;

const PracticeTestInstructions = (props) => {
  const {
    history,
    patchProfile,
    getCurrentProfile,
    me: {
      id: profileId = '',
    } = {},
  } = props;

  const {
    data = {},
  } = useQuery(FIND_SOCIAL_PROFILE_INFORMATION, {
    variables: {
      id: profileId,
    },
    skip: !_.isEmpty(profileId),
  });

  const { socialProfileInformation } = data;

  const [email, setEmail] = useState('');
  const [country, setCountry] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [acceptNewsletter, setAcceptNewsletter] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);

  useEffect(() => {
    if (!_.isEmpty(socialProfileInformation)) {
      setEmail(socialProfileInformation.emailAddress);
    }
  }, [socialProfileInformation]);

  useEffect(() => {
    setMessage('');
    setError(false);
  }, [email]);

  const handleButtonClick = async () => {
    const form = {
      newsletter: acceptNewsletter,
      email,
      country,
      firstName,
      lastName,
    };

    const validationResult = await validateForm(form, acceptTerms);

    if (validationResult.isValid) {
      try {
        setLoading(true);
        await patchProfile(profileId, form);
        getCurrentProfile();
        history.push('/practice-test');
      } catch (err) {
        captureException('HANDLE_PRACTICE_TEST_INSTRUCTIONS_FAILURE', err);
        setLoading(false);
        setError(true);
        setMessage(err.message);
      }
    } else {
      setError(true);
      setMessage(validationResult.message);
    }
  };

  return (
    <Container>
      <Segment>
        <Header as="h3">
          Before you can start taking paid studies, you’ll have to take a practice test so we can
          ensure our clients receive quality videos.
        </Header>

        <Section>
          <Bold>
            Here’s what to expect on the practice test
          </Bold>

          <Text>
            - You’ll download the screen recorder to your computer
          </Text>

          <Text>
            - When you’re taking the study, you will be asked to speak your thoughts out loud
          </Text>

          <Text>
            - The practice test will take approximately 10 minutes
          </Text>

          <Text>
            - Take the study in a quiet place, such as an office or your home
          </Text>

          <Text>
            - Check out a 5-star video example session&nbsp;
            <Link
              href="https://www.youtube.com/watch?v=2U0PfOQNlZg"
              target="_blank"
            >
              here
            </Link>
            .
          </Text>
        </Section>

        <Section>
          <Bold>
            Why do I have to take a practice test?
          </Bold>

          <Text>
            We want to ensure that our customers receive quality video submissions.
            This practice test will determine if you’re approved to start taking tests.
            The PlaybookUX team will let you know if your practice test is accepted and you can
            start taking part in paid studies within 7 days.
          </Text>
        </Section>

        <Section>
          <Bold>
            Requirements
          </Bold>

          <Text>
            You’ll need a Windows or Mac computer to complete this practice test. You must be a proficient English speaker.
          </Text>
        </Section>

        <Section>
          <Row>
            <FirstNameBold>First name</FirstNameBold>
            <NameInput
              value={firstName}
              error={error}
              onChange={({ target: { value } }) => setFirstName(value)}
              loading={loading}
            />
            <LastNameBold>Last name</LastNameBold>
            <NameInput
              value={lastName}
              error={error}
              onChange={({ target: { value } }) => setLastName(value)}
              loading={loading}
            />
          </Row>
        </Section>
        <Section>
          <Row>
            <EmailBold>Email address</EmailBold>
            <Email
              value={email}
              error={error}
              onChange={({ target: { value } }) => setEmail(value)}
              loading={loading}
            />
          </Row>
        </Section>
        <Section>
          <Row>
            <EmailBold>Country</EmailBold>
            <Country
              placeholder="Please select your country"
              error={error}
              options={countryOptions}
              onChange={(e, { value }) => setCountry(value)}
              loading={loading}
            />
          </Row>
        </Section>

        <Section>
          <Checkbox
            label="I agree to receive email communications."
            value={acceptNewsletter}
            checked={acceptNewsletter}
            onChange={() => setAcceptNewsletter(!acceptNewsletter)}
          />

          <br />
          <br />

          <Checkbox
            label={<label dangerouslySetInnerHTML={{ __html: acceptTermsText }} />}
            value={acceptTerms}
            checked={acceptTerms}
            onChange={() => setAcceptTerms(!acceptTerms)}
          />
        </Section>

        {message && <ErrorMessage>{message}</ErrorMessage>}

        <Button onClick={handleButtonClick}>
          Next
        </Button>
      </Segment>
    </Container>
  );
};

PracticeTestInstructions.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  me: PropTypes.any.isRequired,
  patchProfile: PropTypes.func.isRequired,
  getCurrentProfile: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  patchProfile,
  getCurrentProfile,
}, dispatch);

export default compose(
  withLayout({ selectedTab: Tabs.PRACTICE_TEST_INSTRUCTIONS }),
  connect(null, mapDispatchToProps),
)(PracticeTestInstructions);
